import GlobalHelper from "../../common/GlobalHelper"
import { SelectOption } from "../../common/types"
import { SelectedOption } from "../../common/types/select/userSelect"
import { UserDto } from "../../state/user/User"

export const mapUserSelectOptionFromElasticSearch = (selected: Array<UserDto>, filter: () => boolean)
    : Array<SelectOption<string>> => {
    return (selected || [])
        .filter(
            filter ||
                function() {
                    return true
                }
        )
        .map(user => {
            return {
                value: user.id,
                label: GlobalHelper.GetFormattedName(user)
            }
        })
}

export const mapValueAndLabelFromSelectedOption = (
    selectedOption: SelectedOption,
    multi: boolean
): {
    value: Array<string> | string
    label: Array<string> | string
} => {
    let value: Array<string> | string = ""
    let label: Array<string> | string = ""
    if (multi) {
        value = (selectedOption as Array<SelectOption<string>> | []).map(option => option?.value)
        label = (selectedOption as Array<SelectOption<string>> | []).map(option => option?.label).join(",")
    } else {
        value = (selectedOption as SelectOption<string>)?.value
        label = (selectedOption as SelectOption<string>)?.label as string
    }
    return { value, label }
}



// WEBPACK FOOTER //
// ./src/utils/user/utils.ts